<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchData">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        v-model="search.code"
                        placeholder="รหัสสินค้า"
                        aria-label="Search"/>
                    <select class="form-control" v-model="search.type">
                        <option
                            v-for="options in optionProductType"
                            :value="options.value">{{ options.text }}</option>
                    </select>
                    &nbsp; &nbsp;
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchData">
                        <icon name="search"></icon> ค้นหา
                    </button>
                    &nbsp&nbsp
                    <template v-if="canInventoryProductsUpdate">
                        <router-link to="/products-information">
                            <button
                                    class="btn btn-warning my-2 my-sm-0"
                                    type="button">
                                <icon name="plus"></icon>
                                เพิ่มสินค้า
                            </button>
                        </router-link>
                    </template>
                    &nbsp&nbsp
                    <button @click="printReport"
                            class="btn btn-primary my-2 my-sm-0"
                            type="button">
                        <icon name="print"></icon> พิมพ์ใบเสนอราคา
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">สถานะสินค้า</th>
                    <template v-if="canInventoryProductsImport">
                        <th scope="col">นำเข้าสินค้า</th>
                    </template>
                    <template v-if="canInventoryProductsExport">
                        <th scope="col">นำออกสินค้า</th>
                    </template>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนคงเหลือ</th>
                    <template v-if="canInventoryProductsPriceView && canInventoryProductsDetailView">
                        <th scope="col">ราคาขาย/หน่วย</th>
                    </template>
                    <template v-if="canInventoryProductsDetailView">
                        <th scope="col">วันที่อัพเดตล่าสุด</th>
                    </template>
                    <template v-if="canInventoryProductsUpdate">
                        <th scope="col">แก้ไข</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in product">
                    <td>
                        <icon v-if="data.quantity <= data.min_quantity" name="circle" style="color: red;"></icon>
                        <icon v-else name="circle" style="color: green;"></icon>
                    </td>
                    <template v-if="canInventoryProductsImport">
                        <td>
                            <a @click="showImportModal(data.id)">
                                <img src="@/assets/plus_icon.png" width="40px"/>
                            </a>
                        </td>
                    </template>
                    <template v-if="canInventoryProductsExport">
                        <td>
                            <a @click="showExportModal(data.id)">
                                <img src="@/assets/delete_icon.png" width="40px"/>
                            </a>
                        </td>
                    </template>
                    <td>{{ data.sku }}</td>
                    <td>{{ data.name }}</td>
                    <td>
                        {{ data.quantity | amount }}
                    </td>
                    <template v-if="canInventoryProductsPriceView && canInventoryProductsDetailView">
                        <td>{{ data.price | currency }}</td>
                    </template>
                    <template v-if="canInventoryProductsDetailView">
                        <td>{{ data.updated_at | moment("DD/MM/YYYY , HH:mm:ss") }}</td>
                    </template>
                    <template v-if="canInventoryProductsUpdate">
                        <td>
                            <a @click="goToProductInformation(data.id)"><icon name="pencil-alt"></icon></a>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
        </div>
        <!--pagination--->
        <div v-if="product.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getProductsPage">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :status="status" :msg="msg" @submit="hideLoadingModal"></loading>
        </b-modal>
        <!-- Modal import products -->
        <b-modal
            hide-footer
            ref="import_data"
            id="import"
            title="นำเข้าสินค้า">
            <import-data @submit="saveImportProduct">
            </import-data>
        </b-modal>
        <!-- Modal Export Products -->
        <b-modal
            hide-footer
            ref="export_data"
            id="import"
            title="นำออกสินค้า">
            <export-data @submit="saveExportProduct">
            </export-data>
        </b-modal >
        <!--<pre class="alert alert-primary">{{ product }}</pre>-->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import FormTextarea from "bootstrap-vue/src/components/form-textarea/form-textarea";
import ImportData from "../Import/ImportData";
import ExportData from "../Export/ExportData";
import VuePagination from "../../Pagination";
import { domain } from "../../../util/Constants";

import {
    canInventoryProductsImport,
    canInventoryProductsExport,
    canInventoryProductsPriceView,
    canInventoryProductsDetailView,
    canInventoryProductsUpdate
} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";

export default {
    name: "products-list",
    components: {
        Loading,
        VuePagination,
        ExportData,
        ImportData,
        FormTextarea,
        Multiselect
    },
    data() {
        return {
            msg : '',
            status : '',
            id: "",
            option: [{ text: "หมวดหมู่สินค้า", value: "" }],
            event_submit : false,
            dataPaginate:{
                current_page :1,
                from : 1,
                last_page : 1,
                per_page : 1,
                total : 1,
                to : 1
            },
            product : [],
        };
    },
    created() {
        this.$store.dispatch("Products/clearSearch");
        this.$store.dispatch("Products/setProducts").then(res=>{
            this.product = res.data;
            this.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            }
        });
        this.$store.dispatch('ProductType/get');
    },
    computed: {
        canInventoryProductsImport,
        canInventoryProductsExport,
        canInventoryProductsPriceView,
        canInventoryProductsDetailView,
        canInventoryProductsUpdate,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionProductType : state =>{
                return [
                    {
                        value: "",
                        text: "หมวดหมู่สินค้า"
                    },
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            search: state=>{
                return state.Products.search
            }
        })
    },
    methods: {
        //Modal
        showImportModal(id) {
            this.id = id;
            this.showProduct(id);
            this.$refs.import_data.show();
        },
        showExportModal(id) {
            this.id = id;
            this.showProduct(id);
            this.$refs.export_data.show();
        },
        hideImportModal() {
            this.$refs.import_data.hide();
        },
        hideExportModal() {
            this.$refs.export_data.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        //API
        showProduct(id) {
            this.$store.dispatch("Products/show", id);
        },
        goToProductInformation(id){
            this.$store.dispatch("Products/show", id).then(()=>{
                this.$router.push({
                    name : 'products-information',
                    params : {id}
                })
            });
        },
        searchData() {
            this.event_submit = true;
            if (this.search.type === null) {
                this.search.type = "";
            }
            this.$store.dispatch("Products/search", {
                code: this.search.code,
                type: this.search.type
            }).then(res=>{
                this.product = res.data;
                this.dataPaginate = {
                    current_page : res.current_page,
                    from : res.form,
                    last_page : res.last_page,
                    per_page : res.per_page,
                    total : res.total,
                    to : res.to
                }
            });
        },
        saveImportProduct(submitData) {
            if(submitData!==1){
                this.$store
                    .dispatch("ImportProduct/create", submitData)
                    .then(() => {
                        this.getProductsPage();
                        this.hideImportModal();
                    })
            }
            this.hideImportModal();
        },
        saveExportProduct(submitData) {
            if(submitData!==1){
                return this.$store.dispatch("ExportProduct/create", submitData)
                    .then(data => {
                        if(!data){
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                        }
                        else{
                            this.getProductsPage();
                            this.hideExportModal();
                        }
                    })
            }
            this.hideExportModal();
        },
        getProductsPage(){
            const page = this.dataPaginate.current_page;
            this.showLoadingModal();
            this.status = 1;
            this.msg = "กำลังดาวโหลดข้อมล";
            //paginate search
            if(this.event_submit){
                this.$store.dispatch('Products/search',{
                    page : page,
                    code: this.search.code,
                    type: this.search.type
                }).then(()=>{
                    this.hideLoadingModal();
                });
            }else{
                //paginate get data
                this.$store.dispatch('Products/setProducts',page).then(()=>{
                    this.hideLoadingModal();
                })
            }
        },
        printReport(){
            window.open(domain+'/report-product-pdf','_blank');
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
